<template>
  <div>
    <IncidentForm />
  </div>
</template>

<script>
import IncidentForm from '@/components/incident-form/IncidentForm.vue';

export default {
  name: 'ReportIncident',
  components: {
    IncidentForm
  }
}
</script>
